import { useLocation, useNavigate } from 'routes';
import { protectedRouteData } from 'routes/routeData.jsx';
import makeRouterLinks from '../libs/makeRouterLinks';

/**
 * @function useRouterBreadcrumbs.
 * @desc A custom hook for managing breadcrumbs and navigation in a router.
 * @returns {object}
 */
function useRouterBreadcrumbs() {
	const location = useLocation();
	const navigate = useNavigate();

	const linkData = makeRouterLinks(location, protectedRouteData);

	let isDisabledGoBack = linkData.length <= 1;
	let isDisabledGoForword = true;

	const onGoBack = () => {
		if (linkData.length >= 2) {
			const index = linkData.length - 1;
			navigate(linkData[index - 1].link);
		} else {
			console.warn('Cannot go back. No previous links available.');
		}
	};

	return { navigate, isDisabledGoBack, isDisabledGoForword, linkData, onGoBack };
}

export default useRouterBreadcrumbs;
